import { useEffect } from 'react'

import { Track } from '@components/track'
import { GamePhase, useGameStore } from '@stores'

import { useLevelControls } from '@utils'
import { Ground } from './ground'
import { Credits } from './ui'
import { Vehicles } from './vehicles'

export function Level() {
  const { level, ground, vehicles, tracks } = useLevelControls()

  const currentLevelIndex = useGameStore(state => state.currentLevelIndex)
  const phase = useGameStore(state => state.phase)
  const setPhase = useGameStore(state => state.setPhase)

  useEffect(() => {
    useGameStore.setState({ currentLevelIndex: level - 1 })
    useGameStore.getState().nextLevel()
  }, [level, setPhase])

  useEffect(() => {
    if (phase > GamePhase.LOADING) return
    setPhase(
      currentLevelIndex === 0
        ? GamePhase.TITLE
        : currentLevelIndex === 1
          ? GamePhase.LEVEL_SELECTION
          : GamePhase.PLAYING,
    )
  }, [phase, currentLevelIndex, setPhase])

  return (
    <>
      {phase <= GamePhase.TITLE_TRANSITION && <Credits />}

      {vehicles && <Vehicles />}
      {tracks && <Track />}
      {ground && <Ground />}
    </>
  )
}
